import React from "react";

import { Typography } from "@/foundation/Typography/V1";
import theme from "@/foundation/Theme";

import {
  CallBackFormBox,
  Col,
  Group,
  Icon,
  LCol,
  ListItem,
  UList,
  Wrapper,
} from "./style";

const HowItWorksSection = ({ title, list, children, slug }) => (
  <Wrapper>
    <Group>
      <LCol flexDirection="column">
        <Typography variant="title1" mb="40px" color={theme.colors.gray_90}>
          {title}
        </Typography>
        <UList>
          {list?.map((item, index) => {
            return (
              <ListItem key={index}>
                <Icon
                  icon="icon-how-it-work-check"
                  fill={theme.colors.textGradient.type3static}
                />
                <Typography variant="paragraph1" color={theme.colors.gray_90}>
                  {item.text}
                </Typography>
              </ListItem>
            );
          })}
        </UList>
      </LCol>
      <Col>
        <CallBackFormBox>{children}</CallBackFormBox>
      </Col>
    </Group>
  </Wrapper>
);

export default HowItWorksSection;
